import { getGoToBrandReferralsCTA } from "./shared";
export var BrandReferralCreditDiscrepancyIA = function BrandReferralCreditDiscrepancyIA(strictLocalize) {
  return {
    titleBuilder: function titleBuilder(_context) {
      return BRAND_REFERRALS_CREDIT_DISCREPANCY_TITLE(strictLocalize);
    },
    descriptionBuilder: function descriptionBuilder(_context) {
      return [BRAND_REFERRALS_CREDIT_DISCREPANCY_DESCRIPTION(strictLocalize)];
    },
    primaryCtaBuilder: {
      textBuilder: function textBuilder(context) {
        var _getGoToBrandReferral;
        return (_getGoToBrandReferral = getGoToBrandReferralsCTA(context, strictLocalize)) === null || _getGoToBrandReferral === void 0 ? void 0 : _getGoToBrandReferral.label;
      },
      linkBuilder: function linkBuilder(context) {
        var _getGoToBrandReferral2, _getGoToBrandReferral3;
        return (_getGoToBrandReferral2 = getGoToBrandReferralsCTA(context, strictLocalize)) === null || _getGoToBrandReferral2 === void 0 ? void 0 : (_getGoToBrandReferral3 = _getGoToBrandReferral2.getLink) === null || _getGoToBrandReferral3 === void 0 ? void 0 : _getGoToBrandReferral3.call(_getGoToBrandReferral2);
      }
    }
  };
};
var BRAND_REFERRALS_CREDIT_DISCREPANCY_TITLE = function BRAND_REFERRALS_CREDIT_DISCREPANCY_TITLE(strictLocalize) {
  return strictLocalize({
    id: "aP3Gjj",
    defaultMessage: [{
      "type": 0,
      "value": "Pourquoi le crédit ne correspond-il pas ?"
    }]
  });
};
var BRAND_REFERRALS_CREDIT_DISCREPANCY_DESCRIPTION = function BRAND_REFERRALS_CREDIT_DISCREPANCY_DESCRIPTION(strictLocalize) {
  return strictLocalize({
    id: "lhaVmE",
    defaultMessage: [{
      "type": 0,
      "value": "Le montant du crédit dépend de la promotion en cours lorsque vous envoyez la demande de parrainage. Pour que vous puissiez bénéficier du crédit, la marque doit utiliser votre lien de parrainage ou vous sélectionner en tant que parrain lors de son inscription sur Faire. Pour consulter le montant du « Crédit obtenu » pour une marque en particulier, rendez-vous dans « Compte », puis « Parrainer des marques », et sélectionnez l'onglet « Inscrites ». Si l'un des deux messages suivants s'affichent : « N'a pas utilisé votre lien » ou « Déjà active », vous ne pouvez pas bénéficier du crédit de parrainage."
    }]
  });
};